var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPieLineGraph = function SvgPieLineGraph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pie-line-graph_svg__a)",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.037.875H3.287a1.75 1.75 0 0 0-1.75 1.75v22.75c0 .966.784 1.75 1.75 1.75h22.75a1.75 1.75 0 0 0 1.75-1.75V2.625a1.75 1.75 0 0 0-1.75-1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.287 22.75 4.632-4.632a.876.876 0 0 1 1.238 0l2.262 2.263a.876.876 0 0 0 1.238 0l4.63-4.631"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.287 14.875a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5Z",
    fill: "#FFE1CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.287 4.375v5.25l3.712 3.712M19.912 6.125h3.5M19.912 9.625h3.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pie-line-graph_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.667)",
    d: "M0 0h28v28H0z"
  })))));
};

export default SvgPieLineGraph;